import type { AppContextEntity, TellentAssistantAppContext } from '@core/tellent-assistant-types';

// Must stay in sync with the BE ChatAppContextSchema enum — an unknown type fails the whole payload.
export const WIRE_ENTITY_TYPES = <const>['candidate', 'job'];

type WireEntityType = (typeof WIRE_ENTITY_TYPES)[number];

export interface WireAppContext {
  entities: ReadonlyArray<{ type: WireEntityType; id: number; name?: string }>;
}

export function toWireAppContext(ctx: TellentAssistantAppContext): WireAppContext {
  return {
    entities: ctx.entities
      .filter((entity): entity is AppContextEntity & { type: WireEntityType } =>
        (<readonly string[]>WIRE_ENTITY_TYPES).includes(entity.type),
      )
      .map(({ type, id, displayName }) => ({ type, id, name: displayName.trim() || undefined })),
  };
}
